<chr-button-icon *transloco="let t"
                 icon="filter"
                 palette="neutral"
                 variant="tertiary"
                 [attr.aria-label]="t('COMMON.COLLECTIONS.ARIA.BUTTONS.TOGGLE_DRAWER')"
                 data-test-id="sideFilterToggle"
                 (chr-action)="toggleFiltersDrawer()" />
